import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import authApi from '@/services/api/authApi';
import { setUserProfile, resetUser } from '@/store/user/userSlice';
import { setCreditsData, resetCredits } from '@/store/credits/creditsSlice';
import { setIntegrations, resetIntegrations } from '@/store/integrations/integrationsSlice';

export const checkSession = createAsyncThunk(
  'auth/checkSession',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const data = await authApi.getMe();
      if (data.user) dispatch(setUserProfile(data.user));
      if (data.credits) dispatch(setCreditsData(data.credits));
      if (data.integrations) dispatch(setIntegrations(data.integrations));
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const logout = createAsyncThunk(
  'auth/logout',
  async (_, { dispatch }) => {
    try {
      await authApi.logout();
    } catch (_) {
      // Ignore logout API errors — clear local state regardless
    }
    dispatch(resetUser());
    dispatch(resetCredits());
    dispatch(resetIntegrations());
  }
);

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    token: null,
    isAuthenticated: false,
    isInitializing: true,
    error: null,
  },
  reducers: {
    setCredentials(state, action) {
      state.token = action.payload.token;
      state.isAuthenticated = true;
      state.error = null;
    },
    clearCredentials(state) {
      state.token = null;
      state.isAuthenticated = false;
      state.isInitializing = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(checkSession.fulfilled, (state) => {
        state.isAuthenticated = true;
        state.isInitializing = false;
      })
      .addCase(checkSession.rejected, (state) => {
        state.token = null;
        state.isAuthenticated = false;
        state.isInitializing = false;
      })
      .addCase(logout.fulfilled, (state) => {
        state.token = null;
        state.isAuthenticated = false;
        state.isInitializing = false;
      });
  },
});

export const { setCredentials, clearCredentials } = authSlice.actions;
export default authSlice.reducer;
